/* 🤖 this file was generated by svg-to-ts */
export const matIconVolumeDown: {
  name: 'volume-down';
  data: string;
} = {
  name: 'volume-down',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M16 7.97v8.05c1.48-.73 2.5-2.25 2.5-4.02A4.5 4.5 0 0 0 16 7.97zM5 9v6h4l5 5V4L9 9H5zm7-.17v6.34L9.83 13H7v-2h2.83L12 8.83z"/></svg>`
};
